export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-catalog/index.js